<template>
    <div>
        <Header/>
        <Nav :list="headerList"/>
        <div ref="content">
            <SingleBanner/>
            <div class="page-content">
                <div class="page-content-left">
                    <div class="page-content-left-title">{{ifmExamObj.bkap.title}}</div>
                    <div class="page-content-left-time">{{ifmExamObj.bkap.date}}</div>
                    <div class="page-content-left-content" v-html="ifmExamObj.bkap.content"></div>
                </div>
                <div class="page-content-right">
                    <RightTab :list="arr"/>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
</template>
<script>
import RightTab from './components/rightTab.vue';
import { mapState } from 'vuex'
export default {
    computed: mapState([
        'ifmExamObj'
    ]),
    components:{
       RightTab,
    },
    data() {
        return {
            headerList:[
                {name:'首页', href:'/'},
                {name:'IFM考试', href:'/ifmExam'},
                {name:'补考安排', href:'/ifmDesc'},
            ],
            arr:[
                {name:'IFM职业资格考试',url:'/qualificationTest'},
                {name:'认证管理制度',url:'/manageSystem'},
                {name:'补考安排',url:'/makeup'},
                {name:'业界评价',url:'/industryEvaluation'},
            ]
        }
    },
    mounted(){
    },
    methods: {
        
    },
}
</script>
<style lang="scss" scoped>
.news{
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    .single{
        width: 580px;
    }
}
</style>
